export enum AdminRoute {
  empty = '',
  partner = 'partner',
  businessUnits = 'business-units'
}
